import { comparisonModes, filters, TemplateStarringTargets } from '../constants'
import { reconciliationLabelFor } from './shared'

function accountDetailTemplateLabelFor(settings, getters) {
  if (settings.accountDetailTemplateId) {
    return getters.getFilterDropdownValueLabel?.(
      'account_detail_template',
      settings.accountDetailTemplateId
    )
  }

  if (settings.partnerAccountDetailTemplateId) {
    return I18n.t('companies_overview.filters.account_template_not_available')
  }

  return undefined
}

export const templateStarringDefinition = {
  type: filters.TEMPLATE_STARRING,
  nameKey: 'template_starring',
  deployDate: '2026-04-13',
  ledgerRequired: true,

  getColumnTitle(settings, getters) {
    const { target } = settings

    if (target === TemplateStarringTargets.accounts) {
      const adtLabel = accountDetailTemplateLabelFor(settings, getters)

      if (!adtLabel) return ''

      return I18n.t(
        'companies_overview.filters.template_starring.column_title',
        { template_name: adtLabel }
      )
    }

    const reconciliationLabel = reconciliationLabelFor(settings, getters)

    if (!reconciliationLabel) return ''

    return I18n.t('companies_overview.filters.template_starring.column_title', {
      template_name: reconciliationLabel,
    })
  },

  formatForExport(value) {
    if (!value || typeof value === 'string') {
      return value || ''
    }

    if (value.kind === 'accounts') {
      const statusLabel = I18n.t(
        `companies_overview.filters.template_starring.${value.status}`
      )

      return `${statusLabel} ${value.starred_count}/${value.total_count}`
    }

    if (value.kind === 'reconciliation') {
      return I18n.t(
        `companies_overview.filters.template_starring.${
          value.starred ? 'starred' : 'not_starred'
        }`
      )
    }

    return ''
  },

  comparisonModes(target = TemplateStarringTargets.reconciliations) {
    const modes = [
      {
        label: I18n.t('companies_overview.filters.comparison_modes.show_all'),
        value: comparisonModes.SHOW_ALL,
      },
      {
        label: I18n.t(
          'companies_overview.filters.template_starring.not_starred'
        ),
        value: comparisonModes.IS_NOT,
      },
    ]

    if (target === TemplateStarringTargets.accounts) {
      modes.push({
        label: I18n.t(
          'companies_overview.filters.template_starring.partially_starred'
        ),
        value: comparisonModes.PARTIALLY_STARRED,
      })
    }

    modes.push({
      label: I18n.t('companies_overview.filters.template_starring.starred'),
      value: comparisonModes.IS,
    })

    return modes
  },

  serializeSettings(settings) {
    return {
      comparison_mode: settings.comparisonMode,
      reconciliation_text_id: settings.reconciliationTextId,
      partner_reconciliation_text_id: settings.partnerReconciliationTextId,
      target: settings.target,
      account_detail_template_id: settings.accountDetailTemplateId,
      partner_account_detail_template_id:
        settings.partnerAccountDetailTemplateId,
    }
  },

  deserializeSettings(params) {
    return {
      comparisonMode: params.comparison_mode,
      reconciliationTextId: params.reconciliation_text_id,
      partnerReconciliationTextId: params.partner_reconciliation_text_id,
      target: params.target,
      accountDetailTemplateId: params.account_detail_template_id,
      partnerAccountDetailTemplateId: params.partner_account_detail_template_id,
    }
  },

  activeSubtitle(settings, getters) {
    const { comparisonMode, target } = settings

    const comparisonModeLabel = this.comparisonModes(target).find(
      (mode) => mode.value === comparisonMode
    )?.label

    if (target === TemplateStarringTargets.accounts) {
      const adtLabel = accountDetailTemplateLabelFor(settings, getters)

      if (!adtLabel) return ''

      return `${adtLabel} ${comparisonModeLabel}`
    }

    const reconciliationLabel = reconciliationLabelFor(settings, getters)

    if (!reconciliationLabel) return ''

    return `${reconciliationLabel} ${comparisonModeLabel}`
  },
}
